<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card>
      <v-card-title class="d-flex justify-content-center">
        <span class="headline"
          >Collect Funds for Order# {{ localValue.orderNumber }}</span
        >
      </v-card-title>

      <v-card-title>
        A maximum of {{ originalValue }} can be collected. How much would you
        like to collect?
      </v-card-title>

      <v-card-text>
        <b-container>
          <b-row>
            <b-col>
              <v-text-field
                id="amount"
                v-model="localValue.amount"
                label="Amount"
              ></v-text-field>
            </b-col>
          </b-row>
        </b-container>
      </v-card-text>

      <v-card-actions class="d-flex justify-content-between">
        <v-btn @click="close">Cancel</v-btn>
        <v-btn color="success" @click="save">Collect</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AutoNumeric from "autonumeric";

export default {
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        amount: 0.0;
      }
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      originalValue: 0
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.originalValue = this.value.amount;
        this.$nextTick().then(() => {
          let autoNumericElement = AutoNumeric.getAutoNumericElement(
            document.getElementById("amount")
          );
          if (autoNumericElement === null) {
            autoNumericElement = new AutoNumeric("#amount", {
              currencySymbol: "$",
              digitGroupSeparator: ",",
              decimalCharacter: "."
            });
          }
          autoNumericElement.set(this.value.amount);
        });
      } else {
        this.close();
      }
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    save() {
      this.$emit("save");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
